var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"contact-page",attrs:{"value":_vm.promises.fetch}},[_c('Blocks',{attrs:{"blocks":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }